import {wrap} from '../shared/loading-overlay'
// eslint-disable-next-line angular/controller-name
angular.module('app.ui.form.ctrls').controller('EditCandidateCtrl', [
  '$uibModalInstance',
  'data',
  'logger',
  '$rootScope',
  'CandidateProfileApi',
  'candidateId',
  function controller(
    $uibModalInstance,
    data,
    logger,
    $rootScope,
    CandidateProfileApi,
    candidateId
  ) {
    let vm = this
    const broadcastUpdate = () => {
      console.debug('EditCandidateCtrl: broadcasting candidate:update')
      $rootScope.$broadcast('candidate:updated')
    }

    vm.updatedData = {}

    vm.sliderOptions = {
      selectivity: {
        round: 1,
        from: 1,
        to: 6,
        step: 1,
        dimension: '$',
        scale: ['$', '$$', '$$$', '$$$$', '$$$$$', '$$$$$$'],
      },
    }

    console.debug('EditCandidateCtrl data', data)

    if (data.candidate.minSelectivity === null) {
      data.candidate.minSelectivity = 0
    }

    if (
      data.candidate.maxSelectivity === null ||
      data.candidate.maxSelectivity === 0
    ) {
      data.candidate.maxSelectivity = 6
    }

    vm.sliderFilter = {
      selectivity: `${data.candidate.minSelectivity};${data.candidate.maxSelectivity}`,
      defaultSelectivity: `${data.candidate.minSelectivity};${data.candidate.maxSelectivity}`,
    }

    $rootScope.$on('candidate-deleted', (_event, {candidateDeleted}) => {
      if (
        data.candidate.id === candidateDeleted &&
        !$rootScope.isCandidateDeleted
      ) {
        logger.notify('error', 'Candidate is Deleted by Other Admin')
        vm.cancel()
      }
    })
    vm.notify = (type, message) => {
      switch (type) {
        case 'info':
          logger.log(message)
          break
        case 'success':
          logger.logSuccess(message)
          break
        case 'warning':
          logger.logWarning(message)
          break
        case 'error':
          logger.logError(message)
          break
        default:
          break
      }
    }

    // Vm.updatedData.UncategorizedSelectivity = Boolean(
    //   data.candidate.minSelectivity === 0 &&
    //     (data.candidate.maxSelectivity === 0 ||
    //       data.candidate.maxSelectivity === 6)
    // )

    vm.updateSelectivity = () => {
      // If (vm.updatedData.UncategorizedSelectivity)
      //   vm.sliderFilter.selectivity = `0;0`
      // else
      vm.sliderFilter.selectivity = `${data.candidate.minSelectivity};${data.candidate.maxSelectivity}`
    }

    vm.preferencesWizardSetting = data.candidateSettings.find(
      setting => setting.name === 'hide_preferences_wizard'
    )

    if (vm.preferencesWizardSetting === undefined) {
      vm.newSetting = true
      vm.preferencesWizardSetting = {
        userSettings: [{id: 1, hasValue: false, enable: false}],
      }
    }

    vm.noEmail = false
    vm.updatedData.preferencesWizardSetting = angular.copy(
      vm.preferencesWizardSetting
    )
    vm.selectedCandidate = data.candidate
    if (data.candidate.approvalAcceptDate) {
      vm.updatedData.approvedCandidateWelcome = true
      vm.updatedData.approvedCandidateConfirmation = false
      vm.updatedData.approvedCandidate12HourReminder = false
    } else {
      vm.updatedData.approvedCandidateWelcome = true
      vm.updatedData.approvedCandidateConfirmation = false
      vm.updatedData.approvedCandidate12HourReminder = true
    }

    if (data.candidate.approvalStatus === 'Approved') {
      vm.noEmail = true
      vm.updatedData.approvedCandidateWelcome = false
      vm.updatedData.approvedCandidateConfirmation = false
      vm.updatedData.approvedCandidate12HourReminder = false
    }

    vm.consultants = data.assignableAgents
    vm.blockEmployers = data.employersList
    vm.updatedData.candidate = angular.copy(data.candidate)
    vm.updatedData.candidate.LexStepRequired =
      vm.selectedCandidate.LexStepRequired

    vm.changeLawyerStatus = status => {
      if (status === 'lock') {
        vm.updatedData.candidate.approvalStatus = 'Locked'
      } else {
        vm.updatedData.candidate.approvalStatus = 'Approved'
      }
    }

    vm.showHideWelcomeWizard = lawyerPreferencesFlag => {
      vm.lawyerPreferencesFlag = lawyerPreferencesFlag
    }

    vm.getBlockUnBlockEmployers = () => {
      const updatedBlockedEmployer = vm.blockEmployers.filter(
        employer => Boolean(employer) && employer.isSelected === true
      )

      updatedBlockedEmployer.forEach(employer => {
        employer.alreadyBlocked = Boolean(
          data.blockedEmployers.find(
            blockedEmployer =>
              Boolean(blockedEmployer) &&
              blockedEmployer.employerId === employer.id
          )
        )
      })

      const unblockedEmployers = data.blockedEmployers
        .map(blockedEmployer => {
          const blocked = vm.blockEmployers.find(
            employer =>
              Boolean(blockedEmployer) &&
              blockedEmployer.employerId === employer.id
          )
          blockedEmployer.block = blocked ? blocked.isSelected : undefined
          return blockedEmployer
        })
        .filter(employer => employer.block === false)
      return {
        unblockedEmployers,
        updatedBlockedEmployers: updatedBlockedEmployer.filter(
          employer => employer.alreadyBlocked === false
        ),
      }
    }

    const doSave = async () => {
      console.debug('EditCandidateCtrl::doSave:updatedData', vm.updatedData)
      const employersData = vm.getBlockUnBlockEmployers()
      let modalData = {}
      if (
        vm.updatedData.candidate.approvalStatus !==
        data.candidate.approvalStatus
      ) {
        modalData.updatedApprovalStatus =
          vm.updatedData.candidate.approvalStatus
        modalData.approvedCandidateWelcome =
          vm.updatedData.approvedCandidateWelcome
        modalData.approvedCandidateConfirmation =
          vm.updatedData.approvedCandidateConfirmation
        modalData.approvedCandidate12HourReminder =
          vm.updatedData.approvedCandidate12HourReminder
      }

      if (
        vm.updatedData.candidate.lawProfile.qualificationDate !==
        data.candidate.lawProfile.qualificationDate
      ) {
        modalData.updatedQualificationDate =
          vm.updatedData.candidate.lawProfile.qualificationDate
      }

      if (
        (data.candidate.agent === null &&
          vm.updatedData.candidate.agent &&
          vm.updatedData.candidate.agent.id !== 0) ||
        (data.candidate.agent &&
          vm.updatedData.candidate.agent &&
          vm.updatedData.candidate.agent.id !== data.candidate.agent.id)
      ) {
        modalData.updatedAgent = vm.updatedData.candidate.agent.id
      }

      if (vm.sliderFilter.selectivity !== vm.sliderFilter.defaultSelectivity)
        modalData.updatedSelectivityRange = vm.sliderFilter.selectivity

      if (
        vm.newSetting ||
        vm.updatedData.preferencesWizardSetting.userSettings[0].enable !==
          vm.preferencesWizardSetting.userSettings[0].enable
      ) {
        CandidateProfileApi.updateUserSettings(
          candidateId,
          1,
          vm.updatedData.preferencesWizardSetting.userSettings[0].enable
        )
      }

      if (employersData.unblockedEmployers.length > 0)
        vm.updateCandidateUnblockedEmployers(
          candidateId,
          employersData.unblockedEmployers
        )

      if (employersData.updatedBlockedEmployers.length > 0)
        vm.updateCandidateBlockedEmployers(
          candidateId,
          employersData.updatedBlockedEmployers
        )

      await vm.updateCandidateProfile(modalData, candidateId)
      $rootScope.$broadcast('candidate:edited')
      console.debug('EditCandidateCtrl::doSave:modalData', modalData)
      $uibModalInstance.close(modalData)
    }

    vm.save = async () => wrap(doSave)

    vm.updateCandidateProfile = async (data, candidateId) => {
      try {
        console.debug('updateCandidateProfile', data, candidateId)
        const updateProfileDto = {}
        if (data.updatedSelectivityRange) {
          const selectivityArray = data.updatedSelectivityRange.split(';')
          updateProfileDto.minSelectivity = Number(selectivityArray[0])
          updateProfileDto.maxSelectivity = Number(selectivityArray[1])
        }

        if (data.updatedQualificationDate)
          updateProfileDto.lawProfile = {
            qualificationDate: data.updatedQualificationDate,
          }

        if (data.updatedAgent !== undefined)
          updateProfileDto.agentId =
            // eslint-disable-next-line unicorn/no-null
            data.updatedAgent === 0 ? null : data.updatedAgent
        if (Object.keys(updateProfileDto).length > 0) {
          const {
            data: updatedCandidate,
          } = await CandidateProfileApi.updateProfileData(
            candidateId,
            updateProfileDto
          )
          data.updatedCandidateProfile = updatedCandidate
        }

        if (data.updatedApprovalStatus) {
          console.debug('EditCandidateCtrl: approval status has been updated')
          const payload = {
            approvalStatus: data.updatedApprovalStatus,
            approvedCandidateWelcome: data.approvedCandidateWelcome,
            approvedCandidateConfirmation: data.approvedCandidateConfirmation,
            approvedCandidate12HourReminder:
              data.approvedCandidate12HourReminder,
          }
          await CandidateProfileApi.updateCandidateApprovalStatus(
            candidateId,
            payload
          )
          console.debug('CandidateProfileApi.updateCandidateApprovalStatus OK')
        }
      } catch (error) {
        console.error(error)
      }

      broadcastUpdate()
    }

    vm.updateCandidateUnblockedEmployers = async (
      candidateId,
      unblockedEmployers
    ) => {
      const unBlockPayload = {
        employerIds: unblockedEmployers.map(employer => employer.employerId),
        updateValue: false,
      }
      if (unBlockPayload.employerIds.length > 0)
        await CandidateProfileApi.updateUserBlockedEmployers(
          candidateId,
          unBlockPayload
        )
    }

    vm.updateCandidateBlockedEmployers = async (
      candidateId,
      blockedEmployers
    ) => {
      const blockPayload = {
        employerIds: blockedEmployers.map(employer => employer.id),
        updateValue: true,
      }
      if (blockPayload.employerIds.length > 0)
        await CandidateProfileApi.updateUserBlockedEmployers(
          candidateId,
          blockPayload
        )
    }

    vm.cancel = () => {
      $uibModalInstance.dismiss('cancel')
      broadcastUpdate()
    }
  },
])



// WEBPACK FOOTER //
// ./scripts/shared/edit-candidate.ctrl.js